import  {
  DownCircleFilled, ExclamationCircleOutlined,
  MinusCircleFilled,
  UpCircleFilled,
} from '@ant-design/icons';
import { Tooltip } from 'antd';
import React from 'react';

export function renderWithIcon(text: string) {
  if(text === 'undefined%') {
    return (
        <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    );
  }
  if (text === '0%') {
    return (
      <>
        <MinusCircleFilled style={{ color: '#18a2b8', marginRight: 4 }} />
        {text as string}
      </>
    );
  }
  if (text.includes('-')) {
    return (
      <>
        <DownCircleFilled style={{ color: 'green', marginRight: 4 }} />
        {text as string}
      </>
    );
  }
  return (
    <>
      <UpCircleFilled style={{ color: '#ffc108', marginRight: 4 }} />
      {text as string}
    </>
  );
}

export function getReportName(reportName: string) {
  switch (reportName.toLowerCase()) {
    case 'flight':
      return 'Competitive snapshot by Flights';
    case 'airport':
      return 'Competitive snapshot by Airport';
    case 'country':
      return 'Competitive snapshot by Country';
    case 'city':
      return 'Competitive snapshot by City';
    default:
      return reportName;

  }
}
export function downloadCSV(data: any) {

  const headers = Object.keys(data[0]);
  let csvContent = headers.join(",") + "\n"; // Header row
  //@ts-ignore
  data.forEach(flight => {
    const rowValues = headers.map(header => {
      //@ts-ignore
      const value = flight[header];

      // Handle different value types:
      if (typeof value === 'string') {
        // Escape double quotes and commas if present
        return value.includes(',') || value.includes('"') ? `"${value.replace(/"/g, '""')}"` : value;
      } else if (value === null || value === undefined) {
        // Replace null or undefined values with empty strings
        return '';
      } else {
        // For numbers, booleans, etc., simply convert to string
        return value.toString();
      }
    });
    csvContent += rowValues.join(",") + "\n"; // Data row
  })
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

  // Create a Data URL
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = "flight_data.csv"; // Set the filename

  // Create a URL for the blob and set it as the href attribute
  link.href = URL.createObjectURL(blob);

  // Append the link to the body (necessary for Firefox)
  document.body.appendChild(link);

  // Programmatically click the link to trigger the download
  link.click();

  // Remove the link from the document
  document.body.removeChild(link);


}
